import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { RegulationsComponent } from './regulations.component';
import { FilePondModule } from 'ngx-filepond';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    CommonModule,
    FilePondModule,
    TranslateModule
  ],
  declarations: [RegulationsComponent]
})
export class RegulationsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/regulations/regulations.module.ts